module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Transport Execution Details")]), _vm._v(" "), _c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_c('b-button', {
    class: 'ml-4' + _vm.visible ? null : 'collapsed',
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "variant": _vm.Filter.VehicleNofilter ? 'outline-danger' : 'outline-primary',
      "aria-expanded": _vm.visible ? 'true' : 'false',
      "aria-controls": "collapse-4",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        _vm.visible = !_vm.visible
      }
    }
  }, [_vm._v(_vm._s(_vm.Filter.VehicleNofilter ? "Filter ON" : "Filter OFF"))])], 1)], 1), _vm._v(" "), (_vm.visible) ? _c('div', {
    staticClass: "mb-2"
  }, [_c('b-card', [_c('b-collapse', {
    attrs: {
      "id": "collapse-2"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', [_c('b-input-group', [_c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "Type To Search for Vehicle No Filter"
    },
    on: {
      "input": _vm.getVehicleAssignmentData
    },
    model: {
      value: (_vm.Filter.VehicleNofilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "VehicleNofilter", $$v)
      },
      expression: "Filter.VehicleNofilter"
    }
  }), _vm._v(" "), (_vm.iscolLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e(), _vm._v(" "), _c('b-input-group-append', [_c('b-button', {
    staticClass: "ml-1 pull-right",
    staticStyle: {
      "margin-left": "auto"
    },
    attrs: {
      "disabled": !_vm.Filter.VehicleNofilter,
      "size": "sm",
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.clearFilter
    }
  }, [_vm._v("Clear")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.VehicleNoAssignmentDetails.allModuleId && _vm.Filter.VehicleNofilter) ? _c('b-row', [(_vm.VehicleNoAssignmentDetails.AssignmentDetails.tptType_Status) ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [(_vm.VehicleNoAssignmentDetails.AssignmentDetails.assignId) ? _c('b-button', {
    attrs: {
      "variant": "outline-success",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        _vm.goToTrack(_vm.VehicleNoAssignmentDetails.AssignmentDetails.assignId)
      }
    }
  }, [_vm._v("Track Assignment")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.VehicleNoAssignmentDetails.AssignmentDetails.tptType_Status) ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_c('b', [_vm._v("GRN Type :")]), _vm._v("\n                  " + _vm._s(_vm.VehicleNoAssignmentDetails.AssignmentDetails.tptType_Status))])]) : _vm._e(), _vm._v(" "), (_vm.VehicleNoAssignmentDetails.AssignmentDetails.GRNNo) ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_c('b', [_vm._v("GRN NO :")]), _vm._v("\n                  " + _vm._s(_vm.VehicleNoAssignmentDetails.AssignmentDetails.GRNNo))])]) : _vm._e(), _vm._v(" "), (_vm.VehicleNoAssignmentDetails.AssignmentDetails.GRNDate) ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_c('b', [_vm._v("GRN Date :")]), _vm._v("\n                  " + _vm._s(_vm.VehicleNoAssignmentDetails.AssignmentDetails.GRNDate))])]) : _vm._e(), _vm._v(" "), (_vm.VehicleNoAssignmentDetails.AssignmentDetails.GRNCounter) ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_c('b', [_vm._v("GRN Counter :")]), _vm._v("\n                  " + _vm._s(_vm.VehicleNoAssignmentDetails.AssignmentDetails.GRNCounter))])]) : _vm._e(), _vm._v(" "), (_vm.VehicleNoAssignmentDetails.AssignmentDetails.GRRasiedBy) ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_c('b', [_vm._v("GRN Created By :")]), _vm._v("\n                  " + _vm._s(_vm.VehicleNoAssignmentDetails.AssignmentDetails.GRRasiedBy))])]) : _vm._e(), _vm._v(" "), (
    _vm.VehicleNoAssignmentDetails.AssignmentDetails.multipleContainerType
  ) ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_c('b', [_vm._v("Container Type :")]), _vm._v("\n                  " + _vm._s(_vm.VehicleNoAssignmentDetails.AssignmentDetails.multipleContainerType))])]) : _vm._e(), _vm._v(" "), (_vm.VehicleNoAssignmentDetails.AssignmentDetails.containerNo) ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_c('b', [_vm._v("Container No :")]), _vm._v("\n                  " + _vm._s(_vm.VehicleNoAssignmentDetails.AssignmentDetails.containerNo))])]) : _vm._e(), _vm._v(" "), (_vm.VehicleNoAssignmentDetails.AssignmentDetails.vehicleType) ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_c('b', [_vm._v("Vehicle Type :")]), _vm._v("\n                  " + _vm._s(_vm.VehicleNoAssignmentDetails.AssignmentDetails.vehicleType))])]) : _vm._e(), _vm._v(" "), (_vm.VehicleNoAssignmentDetails.AssignmentDetails.vehicleNo) ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_c('b', [_vm._v("Vehicle No :")]), _vm._v("\n                  " + _vm._s(_vm.VehicleNoAssignmentDetails.AssignmentDetails.vehicleNo))])]) : _vm._e(), _vm._v(" "), (_vm.VehicleNoAssignmentDetails.AssignmentDetails.VehicleStatus) ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_c('b', [_vm._v("Vehicle Status :")]), _vm._v("\n                  " + _vm._s(_vm.VehicleNoAssignmentDetails.AssignmentDetails.VehicleStatus))])]) : _vm._e(), _vm._v(" "), (_vm.VehicleNoAssignmentDetails.AssignmentDetails.JobType) ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_c('b', [_vm._v("Job Type :")]), _vm._v("\n                  " + _vm._s(_vm.VehicleNoAssignmentDetails.AssignmentDetails.JobType))])]) : _vm._e(), _vm._v(" "), (_vm.VehicleNoAssignmentDetails.AssignmentDetails.JobNo) ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_c('b', [_vm._v("Job No :")]), _vm._v("\n                  " + _vm._s(_vm.VehicleNoAssignmentDetails.AssignmentDetails.JobNo))])]) : _vm._e(), _vm._v(" "), (_vm.VehicleNoAssignmentDetails.AssignmentDetails.JobDate) ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_c('b', [_vm._v("Job Date :")]), _vm._v("\n                  " + _vm._s(_vm.VehicleNoAssignmentDetails.AssignmentDetails.JobDate))])]) : _vm._e(), _vm._v(" "), (_vm.VehicleNoAssignmentDetails.AssignmentDetails.RasiedBy) ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_c('b', [_vm._v("Job Created By :")]), _vm._v("\n                  " + _vm._s(_vm.VehicleNoAssignmentDetails.AssignmentDetails.RasiedBy))])]) : _vm._e(), _vm._v(" "), (_vm.VehicleNoAssignmentDetails.AssignmentDetails.MBLNO) ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_c('b', [_vm._v("MBL :")]), _vm._v("\n                  " + _vm._s(_vm.VehicleNoAssignmentDetails.AssignmentDetails.MBLNO))])]) : _vm._e(), _vm._v(" "), (_vm.VehicleNoAssignmentDetails.AssignmentDetails.HBLNO) ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_c('b', [_vm._v("HBL :")]), _vm._v("\n                  " + _vm._s(_vm.VehicleNoAssignmentDetails.AssignmentDetails.HBLNO))])]) : _vm._e(), _vm._v(" "), (_vm.VehicleNoAssignmentDetails.AssignmentDetails.transportType) ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_c('b', [_vm._v("Transport Type :")]), _vm._v("\n                  " + _vm._s(_vm.VehicleNoAssignmentDetails.AssignmentDetails.transportType))])]) : _vm._e(), _vm._v(" "), (_vm.VehicleNoAssignmentDetails.AssignmentDetails.sob_date_detected) ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_c('b', [_vm._v("SOB Date :")]), _vm._v("\n                  " + _vm._s(_vm.VehicleNoAssignmentDetails.AssignmentDetails.sob_date_detected))])]) : _vm._e(), _vm._v(" "), (_vm.VehicleNoAssignmentDetails.AssignmentDetails.vessel_voyage) ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_c('b', [_vm._v("Vessel Voyage :")]), _vm._v("\n                  " + _vm._s(_vm.VehicleNoAssignmentDetails.AssignmentDetails.vessel_voyage))])]) : _vm._e(), _vm._v(" "), (_vm.VehicleNoAssignmentDetails.AssignmentDetails.RasiedFrom) ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_c('b', [_vm._v("Branch :")]), _vm._v("\n                  " + _vm._s(_vm.VehicleNoAssignmentDetails.AssignmentDetails.RasiedFrom))])]) : _vm._e(), _vm._v(" "), (_vm.VehicleNoAssignmentDetails.AssignmentDetails.clientName) ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_c('b', [_vm._v("Client :")]), _vm._v("\n                  " + _vm._s(_vm.VehicleNoAssignmentDetails.AssignmentDetails.clientName))])]) : _vm._e(), _vm._v(" "), (_vm.VehicleNoAssignmentDetails.AssignmentDetails.ShippingLine) ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_c('b', [_vm._v("Shipping Line :")]), _vm._v("\n                  " + _vm._s(_vm.VehicleNoAssignmentDetails.AssignmentDetails.ShippingLine))])]) : _vm._e(), _vm._v(" "), (_vm.VehicleNoAssignmentDetails.AssignmentDetails.PICK) ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_c('b', [_vm._v("Pickup :")]), _vm._v("\n                  " + _vm._s(_vm.VehicleNoAssignmentDetails.AssignmentDetails.PICK))])]) : _vm._e(), _vm._v(" "), (_vm.VehicleNoAssignmentDetails.AssignmentDetails.HAND) ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_c('b', [_vm._v("Handover :")]), _vm._v("\n                  " + _vm._s(_vm.VehicleNoAssignmentDetails.AssignmentDetails.HAND))])]) : _vm._e(), _vm._v(" "), (_vm.VehicleNoAssignmentDetails.AssignmentDetails.STUFF) ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_c('b', [_vm._v("Stuffing :")]), _vm._v("\n                  " + _vm._s(_vm.VehicleNoAssignmentDetails.AssignmentDetails.STUFF))])]) : _vm._e(), _vm._v(" "), (_vm.VehicleNoAssignmentDetails.AssignmentDetails.POR) ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_c('b', [_vm._v("POR :")]), _vm._v("\n                  " + _vm._s(_vm.VehicleNoAssignmentDetails.AssignmentDetails.POR))])]) : _vm._e(), _vm._v(" "), (_vm.VehicleNoAssignmentDetails.AssignmentDetails.POL) ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_c('b', [_vm._v("POL :")]), _vm._v("\n                  " + _vm._s(_vm.VehicleNoAssignmentDetails.AssignmentDetails.POL))])]) : _vm._e(), _vm._v(" "), (_vm.VehicleNoAssignmentDetails.AssignmentDetails.POD) ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_c('b', [_vm._v("POD :")]), _vm._v("\n                  " + _vm._s(_vm.VehicleNoAssignmentDetails.AssignmentDetails.POD))])]) : _vm._e(), _vm._v(" "), (_vm.VehicleNoAssignmentDetails.AssignmentDetails.FPOD) ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_c('b', [_vm._v("FPOD :")]), _vm._v("\n                  " + _vm._s(_vm.VehicleNoAssignmentDetails.AssignmentDetails.FPOD))])]) : _vm._e()], 1) : (!_vm.VehicleNoAssignmentDetails.allModuleId && _vm.Filter.VehicleNofilter) ? _c('b-row', [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('strong', [_vm._v("Data Not Found !!!!")])])], 1) : _vm._e()], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "80"
    }
  }, [_c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "Search  Execution No./Booking/BL No./BOE"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.dateStatusList,
      "option-value": "inv",
      "option-text": "int",
      "placeholder": "Select Date Filter"
    },
    on: {
      "input": function($event) {
        _vm.viewQuotation('0', '1', '1')
      }
    },
    model: {
      value: (_vm.dateStatusFilter),
      callback: function($$v) {
        _vm.dateStatusFilter = $$v
      },
      expression: "dateStatusFilter"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Vehicle Status")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.VehicleStatusList,
      "option-value": "val",
      "option-text": "status",
      "placeholder": "Select Vehicle Status"
    },
    on: {
      "input": function($event) {
        _vm.viewQuotation('0', '1', '1')
      }
    },
    model: {
      value: (_vm.vehicleStatusFilter),
      callback: function($$v) {
        _vm.vehicleStatusFilter = $$v
      },
      expression: "vehicleStatusFilter"
    }
  })], 1)], 1), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "text-muted pull-right mt-2"
  }, [_c('small', [_vm._v(_vm._s(_vm.totalRows) + " Entries")])])]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive tableMain mt-2"
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.veiwQuotationForm,
      "fields": _vm.fields,
      "per-page": _vm.perPage,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "quotationId",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.index + 1 + (_vm.currentPage - 1) * _vm.perPage))])]
      }
    }, {
      key: "mainSalesSeries",
      fn: function(row1) {
        return [(row1.item.seenExec == '0') ? _c('b-badge', {
          attrs: {
            "variant": "danger"
          }
        }, [_vm._v("New\n                "), _c('br')]) : _vm._e(), _vm._v(" "), _c('b', {
          staticClass: "showMoreData",
          style: (row1.item.seenExec == '0' ? 'color:red' : 'color:black'),
          on: {
            "click": function($event) {
              row1.item.is_locked == '1' &&
                (row1.item.finalBillingCompleted == 1 ||
                  row1.item.locked_counter > 0) &&
                _vm.$sessionsStorage.get('designation') != 'Admin' &&
                _vm.$sessionsStorage.get('nameUser') != 'Bhavneesh' ?
                '' :
                _vm.viewQuotationpage(
                  row1.item.clientId,
                  row1.item.salesBookingId,
                  row1.item.quotationId,
                  row1.item.assignId,
                  row1.item.expireStatus,
                  row1.item
                )
            }
          }
        }, [_vm._v(_vm._s(row1.item.mainSalesSeries))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Generated On : " + _vm._s(_vm._f("moment")(row1.item.loginTime)))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("\n                Valid Till : " + _vm._s(_vm._f("moment")(row1.item.validityDate)) + "\n                "), _c('br')]), _vm._v(" "), (row1.item.additionalAssignmentNo) ? _c('span', {
          staticStyle: {
            "color": "green"
          }
        }, [_vm._v("Additional Assignment :"), _c('b', [_vm._v("\n                  " + _vm._s(row1.item.additionalAssignmentNo))])]) : _vm._e(), _vm._v(" "), (
          row1.item.containerAdded != '' && row1.item.containerAdded != null
        ) ? _c('div', [(
          row1.item.totalContainer !=
          row1.item.containerAdded.split(',').length
        ) ? _c('h6', [_c('b-badge', {
          attrs: {
            "variant": "info"
          }
        }, [_vm._v("Incomplete Execution")])], 1) : _vm._e()]) : _c('div', [_c('h6', [_c('b-badge', {
          attrs: {
            "variant": "info"
          }
        }, [_vm._v("Incomplete Execution")])], 1)]), _vm._v(" "), (row1.item.vehicleReleaseDateAdded) ? _c('div', [(!row1.item.vehicleReleaseDateAdded.split(',').includes('0') &&
          row1.item.totalContainer ==
          row1.item.vehicleReleaseDateAdded.split(',').length
        ) ? _c('h6', [_c('b-badge', {
          attrs: {
            "variant": "success"
          }
        }, [_vm._v("Execution Done")])], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('b-button', {
          staticClass: "mt-2",
          staticStyle: {
            "font-size": "0.675rem"
          },
          attrs: {
            "size": "sm",
            "variant": row1.item.is_locked == '1' &&
              (row1.item.finalBillingCompleted == 1 || row1.item.locked_counter > 0) ?
              'danger' :
              'success'
          },
          on: {
            "click": function($event) {
              row1.item.is_locked == '1' &&
                (row1.item.finalBillingCompleted == 1 || row1.item.locked_counter > 0) ?
                _vm.LockUnLock(row1.item, 'locked') :
                ''
            }
          }
        }, [(
          row1.item.is_locked == '1' &&
          (row1.item.finalBillingCompleted == 1 ||
            row1.item.locked_counter > 0)
        ) ? _c('b', [_c('i', {
          staticClass: "fa fa-lock mr-1 lg"
        }), _vm._v("LOCKED")]) : _c('b', [_c('i', {
          staticClass: "fa fa-unlock mr-1 lg"
        }), _vm._v("UN-LOCKED")])]), _c('br'), _vm._v(" "), _c('b-button', {
          attrs: {
            "size": "sm",
            "variant": "outline-dark"
          },
          on: {
            "click": function($event) {
              _vm.showDocModal(row1.item)
            }
          }
        }, [_vm._v("Summary & Documents")]), _vm._v(" "), _c('Assignment-Summary', {
          attrs: {
            "title": 'Shipment Summary Tracking - ',
            "fk_all_module_id": row1.item.allModuleId,
            "jb_series": row1.item.mainSalesSeries
          }
        }), _vm._v(" "), (row1.item.allModuleId) ? _c('ContainerSummary', {
          attrs: {
            "PMC_title": 'Container Summary Job No - ' + row1.item.mainSalesSeries,
            "PMC_JOBID": row1.item.allModuleId,
            "PMC_JOBNO": row1.item.mainSalesSeries,
            "PMC_JOBDATE": '',
            "PMC_JOBTYPE": '',
            "PMC_AgentType": '',
            "PMC_Client": '',
            "PMC_Sline": ''
          }
        }) : _vm._e(), _vm._v(" "), (row1.item.allModuleId) ? _c('AssignmentSplitMergeSummary', {
          attrs: {
            "PMC_title": 'Assignment Split/Merge/Move Summary Job No - ' + row1.item.mainSalesSeries,
            "PMC_JOBID": row1.item.allModuleId,
            "PMC_JOBNO": row1.item.mainSalesSeries,
            "PMC_JOBDATE": '',
            "PMC_JOBTYPE": '',
            "PMC_AgentType": '',
            "PMC_Client": '',
            "PMC_Sline": ''
          }
        }) : _vm._e(), _vm._v(" "), (row1.item.jobType.indexOf('FF') < 0) ? _c('Overseas-CRDRNote', {
          attrs: {
            "title": row1.item.mainSalesSeries,
            "moduleType": 'TPT ' + row1.item.transportType + ' Module',
            "cr_all_module_id": row1.item.allModuleId,
            "cr_jb_series": row1.item.mainSalesSeries,
            "cr_ass_date": _vm._f("moment")(row1.item.loginTime),
            "transportType": row1.item.transportType,
            "Jobtype": 'TPT',
            "commonId": row1.item.quotationId,
            "shipmentType": row1.item.shipmentType == '1' ||
              row1.item.shipmentType == 'Sea_Shipment' ?
              'Sea' :
              'Air',
            "isOverseas": false,
            "ItemAr": null
          }
        }) : _vm._e(), _vm._v(" "), _c('MSDeleteRequest', {
          attrs: {
            "item": row1.item,
            "JobNo": row1.item.mainSalesSeries,
            "JobID": row1.item.allModuleId,
            "sessionsStorage": _vm.$sessionsStorage
          },
          on: {
            "refreshData": _vm.handleRefresh
          }
        }), _vm._v(" "), (row1.item.deleteRequestBy != '' && row1.item.deleteRequestBy != '0' && row1.item.deleteRequestBy != null) ? _c('b', [_vm._v("Requested By : " + _vm._s(row1.item.deleteRequestBy)), _c('br')]) : _vm._e(), _vm._v(" "), (row1.item.deleteArrovedBy != '' && row1.item.deleteArrovedBy != '0' && row1.item.deleteArrovedBy != null) ? _c('b', [_vm._v("Arroved By : " + _vm._s(row1.item.deleteArrovedBy)), _c('br')]) : _vm._e()]
      }
    }, {
      key: "clientName",
      fn: function(row11) {
        return [_c('b', {
          style: (row11.item.seenExec == '0' ? 'color:red' : 'color:black')
        }, [_vm._v(_vm._s(row11.item.clientName))])]
      }
    }, {
      key: "multipleContainerType",
      fn: function(row11) {
        return [_c('span', [_vm._v("Container Type : " + _vm._s(row11.item.multipleContainerType))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("\n                No. of Containers : " + _vm._s(row11.item.multiConNo) + "\n                "), _c('br')]), _vm._v(" "), (
          row11.item.containerAdded != '' && row11.item.containerAdded != null
        ) ? _c('span', {
          staticClass: "error"
        }, [_vm._v("\n                " + _vm._s(row11.item.containerAdded) + "\n                No. of Containers Executed :\n                " + _vm._s(row11.item.containerAdded.split(",").length) + "\n                "), _c('br')]) : _c('span', {
          staticClass: "error"
        }, [_vm._v("No. of Containers Executed : 0\n                "), _c('br')]), _vm._v(" "), _c('Add-Message', {
          staticStyle: {
            "list-style-type": "none"
          },
          attrs: {
            "fk_all_module_id": row11.item.allModuleId,
            "fk_client_id": row11.item.clientId,
            "fk_pod_id": row11.item.PODLocationId
          }
        })]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', [_c('h5', [_c('b-pagination', {
    attrs: {
      "limit": "5",
      "align": "center",
      "per-page": _vm.perPage,
      "total-rows": _vm.totalRows
    },
    on: {
      "change": function($event) {
        _vm.onPageChange($event)
      }
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1)]), _vm._v(" "), _c('b-modal', {
    ref: "modal-lock-conf",
    attrs: {
      "id": "modal-lock-conf",
      "title": "Reason for Open Locked Assignment",
      "centered": "",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": ""
    }
  }, [_c('h3', [_vm._v("Confirmation")]), _vm._v(" "), _c('form', {
    ref: "form"
  }, [_c('b-form-group', {
    attrs: {
      "label": "Remark",
      "label-for": "name-input",
      "invalid-feedback": "Name is required"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "rows": "5",
      "id": "name-input",
      "required": ""
    },
    model: {
      value: (_vm.lockReason),
      callback: function($$v) {
        _vm.lockReason = $$v
      },
      expression: "lockReason"
    }
  })], 1)], 1), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": _vm.closeLockUnLockConfirm
    }
  }, [_vm._v(" Cancel")]), _vm._v(" "), (_vm.lockReason) ? _c('b-button', {
    staticClass: "pull-right",
    attrs: {
      "disabled": _vm.lock_button ? true : false,
      "variant": "success"
    },
    on: {
      "click": _vm.ConfLock
    }
  }, [_vm._v("Send")]) : _vm._e()], 1), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  }), _vm._v(" "), _c('div', [_c('b-modal', {
    ref: "doc-modal",
    staticClass: "modal-dialog-doc",
    attrs: {
      "size": "xl",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": "",
      "title": 'Assignment Summary & Documents - ' + _vm.JOBSERIES
    }
  }, [(_vm.ALLMODULE) ? _c('div', [_c('doc-form', {
    attrs: {
      "allModuleIdProp": _vm.ALLMODULE,
      "JOBSERIES": _vm.JOBSERIES
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "outline-danger",
      "block": ""
    },
    on: {
      "click": _vm.hideDocModal
    }
  }, [_vm._v("Close\n          ")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8a16108a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/view/listView/viewQuotation.vue
// module id = 2795
// module chunks = 0